var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5757 7.01935H12.4121V14.5108H16.5757V7.01935Z",
    fill: "#FF5A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6891 10.765C12.6891 9.243 13.4036 7.89213 14.4999 7.01932C13.6931 6.38398 12.6753 6 11.5651 6C8.93512 6 6.80713 8.13116 6.80713 10.765C6.80713 13.3989 8.93512 15.5301 11.5651 15.5301C12.6753 15.5301 13.6931 15.1461 14.4999 14.5108C13.402 13.6503 12.6891 12.2871 12.6891 10.765Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1928 10.765C22.1928 13.3989 20.0648 15.5301 17.4348 15.5301C16.3247 15.5301 15.3068 15.1461 14.5 14.5108C15.6102 13.6364 16.3108 12.2871 16.3108 10.765C16.3108 9.243 15.5963 7.89213 14.5 7.01932C15.3053 6.38398 16.3231 6 17.4333 6C20.0648 6 22.1928 8.14504 22.1928 10.765Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.921d65ce38bedbfff910957a438429e2.svg";
export { ForwardRef as ReactComponent };